import React, { Component } from 'react'
import axios from 'axios';
import swal from 'sweetalert';
import Select from 'react-select'
import DatePicker from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import ls from 'local-storage'

class OfficeSetup extends Component {
    constructor(props){
        super(props);   
        this.state = {
          errors: {},
          departmentlist: [], 
          districtlist: [],
          talukalist: [],
          villagelist: [],
          officelist: [],
          details:{}
        }  
        this.handleChange = this.handleChange.bind(this);  
        this.selecthandleChange = this.selecthandleChange.bind(this);  
        this.departmentchange = this.departmentchange.bind(this);   
           
      }    
      componentDidMount() { 
        const Axios = axios.create({
          baseURL: process.env.REACT_APP_API_URL,
        });
        const loginToken = ls.get('loginToken');
        Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;                 
        document.title = "Office Set-Up" 

        if(this.props.match.params.id){
          Axios.get(`${process.env.REACT_APP_API_URL}master/officesetup/id/`+this.props.match.params.id)
        .then(result=>{ 
          if(result.status === 200){
            this.setState({details:result.data});     
             if(result.data.department_id !== ''){
                    const a = {'value':result.data.department_id};
                    this.departmentchange('department_id',a);
                } 
                if(result.data.dcode !== '') {     
                    const a = {'value':result.data.dcode};
                    this.departmentchange('dcode',a);                  
                }  
                if(result.data.tcode !== '') {     
                    const a = {'value':result.data.tcode};
                    this.departmentchange('tcode',a);                   
                }           
          }      
        });                
      }    
     
      Axios.get(`${process.env.REACT_APP_API_URL}master/getdepartment`)
        .then(result=>{
            const options = result.data.map(d => ({
              "value" : d.department_id,
              "label" : d.department_name          
            }))    
            this.setState({departmentlist: options})             
        }); 
        Axios.post(`${process.env.REACT_APP_API_URL}master/getdistrict`,{statecode:'GJ'})
        .then(result=>{
            const options = result.data.map(d => ({
              "value" : d.dcode,
              "label" : d.dname          
            }))    
            this.setState({districtlist: options})             
        });        
                                         
      } 
      handleValidation(){
        let details = this.state.details;        
        let errors = {};
        let formIsValid = true;
        
        //Department Name
        if(!details["department_id"]){
          formIsValid = false;
          errors["department_id"] = "Please Select Department Name";
        }
        
        if(typeof details["department_id"] !== "undefined"){
          if(typeof details["department_id"]!== "number"){
            formIsValid = false;
            errors["department_id"] = "Only Number ";
          }      	
        } 
        //Parent Office
        if(!details["parent_officecode"]){
            formIsValid = false;
            errors["parent_officecode"] = "Please Select Parent Office";
          }

          if(typeof details["parent_officecode"] !== "undefined"){
            if(typeof details["parent_officecode"] !== "number"){
              formIsValid = false;
              errors["parent_officecode"] = "Only Number";
            }      	
          }
        //Office Name
        if(!details["officename"]){
          formIsValid = false;
          errors["officename"] = "Please Enter Office Name";
        }    
        if(typeof details["officename"] !== "undefined"){
          if(!details["officename"].match(/^[a-zA-Z0-9_ ,.-]+$/)){
            formIsValid = false;
            errors["officename"] = "Only Letter";
          }      	
        }     
        this.setState({errors: errors});
        return formIsValid;
      }
    
      contactSubmit(e){        
        e.preventDefault();
        if(this.handleValidation()){
          const Axios = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
          });
          const loginToken = ls.get('loginToken');
          Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;          
          const data =  this.state.details; 
          Axios.post(`${process.env.REACT_APP_API_URL}master/officesetupinsert`, data) 
            .then((responce) => { 
              console.log(responce);
              const status = responce.status;
              const result = responce.data;
              if(status === 200 ){
              if(result.status === 1){
                swal({
                  title: result.msg,
                  text: "Redirect To Office List",
                  icon: "success",
                  buttons: true
                })
                .then((responce) => {
                  if (responce) {
                    this.props.history.push({  
                      pathname: '/officelist'
                    });                   
                  } else {
                    this.props.history.push({  
                      pathname: '/officesetup'
                    }); 
                  }
                });
            }
            else{
              swal("Error", result.msg, "error");               
            } 
          }             
            });
        }else{
          swal("Error", "Plese Entry * Fiels", "error");          
        }    
      }    
      async handleChange(event) {
        let details = this.state.details;
        let errors = this.state.errors;
        details[event.target.name] = event.target.value;  
        errors[event.target.name] = '';       
        this.setState({details,errors});       
      }  
      async selecthandleChange(name,e) {
        let details = this.state.details;        
        let errors = this.state.errors;
        details[name] = e.value;   
        errors[name] = '';       
        this.setState({details,errors}); 
      }     
  
      async departmentchange(name,e){       
        let details = this.state.details;
        let errors = this.state.errors;
        details[name] = e.value;  
        errors[name] ='';
        this.setState({details});
        const Axios = axios.create({
          baseURL: process.env.REACT_APP_API_URL,
        });
        const loginToken = ls.get('loginToken');
        Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;   
          if(name === 'department_id') {     
              const result = await Axios.post(`${process.env.REACT_APP_API_URL}master/getoffice`,{'depatment':e.value})
              const options = result.data.map(d => ({
                  "value" : d.officecode,
                  "label" : d.officename      
                }))    
                this.setState({officelist: options}) 
          }
          if(name === 'dcode') {     
            const result = await Axios.post(`${process.env.REACT_APP_API_URL}master/gettaluka`,{'dcode':e.value})
            const options = result.data.map(d => ({
                "value" : d.tcode,
                "label" : d.name_e      
              }))    
              this.setState({talukalist: options}) 
          }  
          if(name === 'tcode') {     
            const result = await Axios.post(`${process.env.REACT_APP_API_URL}master/getvillage`,{'tcode':e.value})
            const options = result.data.map(d => ({
                "value" : d.vcode,
                "label" : d.name_e      
              }))    
              this.setState({villagelist: options}) 
          } 
          console.log(this.state.details) ;       
      }   
      datepickerhandleChange(name,e){
        let details = this.state.details;
        details[name] = e.format('DD-MM-YYYY');
        this.setState({details});
      }
      Greeting() {
        if(this.props.match.params.id){ 
        return (                              
              <div className="col-md-12">
              <div className="col-md-6">
                <div className="form-group">
                    <label>Status</label>
                    <select value={this.state.details.status || ''} className="form-control select2" name="status" onChange={this.handleChange}>
                      <option value="A" >Active</option>
                      <option value="C" >Closed</option>
                    </select>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                    <label className="control-label">Start Date</label>
                    <DatePicker 
                        timeFormat={false}
                        onChange={this.datepickerhandleChange.bind(this,'startdate')}
                        dateFormat="DD-MM-YYYY" 
                        selected={this.state.details.startdate}
                        value={this.state.details.startdate || ''}
                        closeOnSelect 
                    />	
                </div>
              </div>
          </div>
          );
        }
      }                
    render() {  
        return (
                <div className="content-wrapper">                  
                  <section className="content-header">
                      <h1>
                        Office Set-Up
                        <small>it all starts here</small>
                      </h1>
                      <ol className="breadcrumb">
                        <li><i className="fa fa-dashboard"></i> Home</li>
                        <li>Office List</li>
                        <li className="active">Office Set-Up</li>
                      </ol>
                  </section>
                  <section className="content">
                      <div className="box">
                        <div className="box-body">
                            <form onSubmit= {this.contactSubmit.bind(this)} >
                            <div className="col-md-12">
                                  <div className="col-md-6">
                                    <div className="form-group required">
                                        <label className="control-label">Department</label>
                                        <Select 
                                        options={this.state.departmentlist} 
                                        value={this.state.departmentlist.filter(({value}) => value === this.state.details.department_id) || ''}                                        
                                        name="department_id" 
                                        onChange={this.departmentchange.bind(this,'department_id')} 
                                        />                                      
                                        <span className="text-red">{this.state.errors["department_id"]}</span>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group required">
                                        <label className="control-label">Parent Office</label>	
                                        <Select 
                                        options={this.state.officelist} 
                                        name="parent_officecode" 
                                        value={this.state.officelist.filter(({value}) => value === this.state.details.parent_officecode) || ''} 
                                        onChange={this.selecthandleChange.bind(this,'parent_officecode')} 
                                        />
                                        <span className="text-red">{this.state.errors["parent_officecode"]}</span>					
                                    </div>
                                  </div>
                              </div>                               
                              <div className="col-md-12">
                                  <div className="col-md-6">
                                    <div className="form-group required">
                                        <label className="control-label">Office Name</label>
                                        <textarea className="form-control" name="officename" cols="50" rows="2" onChange={this.handleChange} value={ this.state.details.officename || '' } />
                                        <span className="text-red">{this.state.errors["officename"]}</span>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Office Name Local Language</label>
                                        <textarea className="form-control" name="officename_local_lg" cols="50" rows="2" onChange={this.handleChange} value={ this.state.details.officename_local_lg || '' } />								
                                    </div>
                                  </div>
                              </div>   
                              <div className="col-md-12">
                                  <div className="col-md-6">
                                    <div className="form-group required">
                                        <label className="control-label">District Name</label>
                                        <Select 
                                        options={this.state.districtlist} 
                                        value={this.state.districtlist.filter(({value}) => value === this.state.details.dcode) || ''}                                        
                                        name="dcode" 
                                        onChange={this.departmentchange.bind(this,'dcode')} 
                                        />                                      
                                        <span className="text-red">{this.state.errors["dcode"]}</span>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Taluka Name</label>	
                                        <Select 
                                        options={this.state.talukalist} 
                                        name="tcode" 
                                        value={this.state.talukalist.filter(({value}) => value === this.state.details.tcode) || ''} 
                                        onChange={this.departmentchange.bind(this,'tcode')} 
                                        />					
                                    </div>
                                  </div>
                              </div>                               
                              <div className="col-md-12">
                                  <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Village Name</label>
                                        <Select 
                                        options={this.state.villagelist} 
                                        name="vcode" 
                                        value={this.state.villagelist.filter(({value}) => value === this.state.details.vcode) || ''} 
                                        onChange={this.selecthandleChange.bind(this,'vcode')} 
                                        />
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Address</label>
                                        <input className="form-control" type="text" value={this.state.details.full_address || ''} name="full_address" onChange={this.handleChange} />
                                        <span className="text-red">{this.state.errors["full_address"]}</span>								
                                    </div>
                                  </div>
                              </div>                                                      
                              {this.Greeting() }
                              <div className="col-md-12">
                              <div className="col-md-6">
                                  <div className="form-group">
                                      <label>Latitude </label>
                                      <input className="form-control" type="text" value={this.state.details.latitude || ''} name="latitude" onChange={this.handleChange} />
                                  </div>
                              </div> 
                              <div className="col-md-6">
                                  <div className="form-group">
                                      <label>Longitude </label>
                                      <input className="form-control" type="text" value={this.state.details.longitude || ''} name="longitude" onChange={this.handleChange} />
                                  </div>
                              </div>                               
                              </div>
                              <div className="col-md-12">
                                  <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Remark</label>
                                        <textarea className="form-control" name="remarks" cols="50" rows="2" onChange={this.handleChange} value={this.state.details.remarks || ''} /> 
                                    </div>
                                  </div>
                              </div>
                              <div className="box-footer">
                                  <button type="submit" className="btn btn-primary">Save</button>
                              </div>
                            </form>
                        </div>
                      </div>
                  </section>
                </div>           
        )
    }
}
export default OfficeSetup